import { motion } from "framer-motion";
import PageBreadcrumb from "components/shared-components/PageBreadcrumb";

export default function OrdersHeader() {
  return (
    <div className="flex flex-col sm:flex-row w-full items-start sm:items-center justify-between py-6 sm:py-8 space-y-4 sm:space-y-0">
      {/* Left section */}
      <motion.div
        initial={{ x: -20, opacity: 0 }}
        animate={{
          x: 0,
          opacity: 1,
          transition: { delay: 0.2, duration: 0.5 },
        }}
        className="w-full"
      >
        <PageBreadcrumb className="mb-3" />
        <h1 className="text-xl sm:text-xl font-extrabold tracking-tight text-text">
          Orders
        </h1>
      </motion.div>

      {/* Right section (reserved for actions / buttons) */}
      <div className="flex w-full sm:w-auto justify-end items-center space-x-3">
        {/* Example: Add filters or buttons here later */}
        <button className="px-4 py-2 text-sm bg-redlight text-white rounded-md hover:bg-dry hover:text-redlight hover:border hover:border-redlight transition">
          New
        </button>
      </div>
    </div>
  );
}

// import Typography from "@mui/material/Typography";
// import { motion } from "framer-motion";
// import PageBreadcrumb from "components/shared-components/PageBreadcrumb";

// /**
//  * The orders header.
//  */
// function OrdersHeader() {
//   return (
//     <div className="flex grow-0  flex-1 w-full items-center justify-between  space-y-8 sm:space-y-0 py-24 sm:py-32">
//       <motion.span
//         initial={{ x: -20 }}
//         animate={{
//           x: 0,
//           transition: { delay: 0.2 },
//         }}
//       >
//         <div>
//           <PageBreadcrumb className="mb-8" />
//           <Typography className="flex text-4xl font-extrabold leading-none tracking-tight">
//             Orders
//           </Typography>
//         </div>
//       </motion.span>

//       <div className="flex w-full sm:w-auto flex-1 items-center justify-end space-x-8" />
//     </div>
//   );
// }

// export default OrdersHeader;
